import React from 'react';
import styles from './file.module.css'

// icons
import file from '../../brand/generated/file.svg';

const File = () => {
  return (
    <div className={styles.file}>
      <img src={file} alt="Icon" />
      <span>Ð¤Ð°Ð¹Ð».PDF</span>
    </div>
  );
};

export default File;
